export interface LiveResource<T> {
  data: T | null;
  source: string | null;
  freshAt: Date | null;
  fetchedAt: Date | null;
  stale: boolean;
  error: unknown;
  isLoading: boolean;
}

interface QueryLike<T> {
  data: T | undefined;
  isPending: boolean;
  error: unknown;
  dataUpdatedAt: number;
}

interface LiveOptions<T> {
  source?: (data: T) => string | null | undefined;
  freshAt?: (data: T) => Date | null | undefined;
  staleAfterMs?: number;
}

export const toLiveResource = <T>(
  query: QueryLike<T>,
  options: LiveOptions<T> = {},
): LiveResource<T> => {
  const data = query.data ?? null;
  const fetchedAt = query.dataUpdatedAt ? new Date(query.dataUpdatedAt) : null;
  const freshAt = data != null ? options.freshAt?.(data) ?? fetchedAt : null;
  const stale =
    freshAt != null && options.staleAfterMs != null
      ? Date.now() - freshAt.getTime() > options.staleAfterMs
      : false;

  return {
    data,
    source: data != null ? options.source?.(data) ?? null : null,
    freshAt,
    fetchedAt,
    stale,
    error: query.error ?? null,
    isLoading: query.isPending,
  };
};
